import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import { Link } from "react-router-dom";

export default function VideoPromoDestino({
  background,
  YoutubeVideoId,
  TextoPromo,
}) {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <section
        id="download"
        className="video-promo ptb-100 background-img"
        style={{
          background: `url('${background}')no-repeat center center / cover`,
        }}
      >
        <div className="container">
          {YoutubeVideoId ? (
            <>
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <div className="video-promo-content mt-4 text-center">
                    <Link
                      className="popup-youtube video-play-icon d-inline-block"
                      onClick={() => setOpen(true)}
                    >
                      <span className="ti-control-play"></span>
                    </Link>
                    <h5 className="mt-4 text-white">{TextoPromo}</h5>
                  </div>
                </div>
              </div>

              <ModalVideo
                channel="youtube"
                isOpen={isOpen}
                // videoId="mTXw2E_1wIQ"
                videoId={YoutubeVideoId}
                onClose={() => setOpen(false)}
              />
            </>
          ) : null}
        </div>
      </section>
    </>
  );
}
